import Lottie from 'lottie-react';
import classNames from 'classnames';
import paymentReceivedPayOnReg from '../../../../../animations/post-payment_v1.json';
import paymentReceived from '../../../../../animations/payment-received.json';
import './PaymentSuccess.scss';

export default function PaymentSuccess({ isPayOnReg = false }) {
  return (
    <div
      className={classNames('PaymentSuccess', {
        'PaymentSuccess--payonreg': isPayOnReg,
      })}
    >
      <Lottie
        animationData={isPayOnReg ? paymentReceivedPayOnReg : paymentReceived}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
}
